import { ShipmentStatusFilter } from "../constants/shipment-status-filter.ts";

export const filterMappings = {
	isImmediateAction: {
		status: null,
		needsImmediateAction: true,
		needsAcknowledgment: false,
	},
	isNeedsAcknowledged: {
		status: null,
		needsImmediateAction: false,
		needsAcknowledgment: true,
	},
	isNotDispatched: {
		status: ShipmentStatusFilter.TodaysShipmentsNotDispatched,
		needsImmediateAction: false,
		needsAcknowledgment: false,
	},
	isPastPickups: {
		status: ShipmentStatusFilter.PastPickupsNotYetTracking,
		needsImmediateAction: false,
		needsAcknowledgment: false,
	},
	isPickupsGoodStanding: {
		status: ShipmentStatusFilter.TodaysPickupsInGoodStanding,
		needsImmediateAction: false,
		needsAcknowledgment: false,
	},
	isPickupsOutstanding: {
		status: ShipmentStatusFilter.TodaysPickupsOutstanding,
		needsImmediateAction: false,
		needsAcknowledgment: false,
	},
	isTransitGoodStanding: {
		status: ShipmentStatusFilter.InTransitInGoodStanding,
		needsImmediateAction: false,
		needsAcknowledgment: false,
	},
	isTransitOutstanding: {
		status: ShipmentStatusFilter.InTransitOutstanding,
		needsImmediateAction: false,
		needsAcknowledgment: false,
	},
	isDeliveriesGoodStanding: {
		status: ShipmentStatusFilter.TodaysDeliveriesInGoodStanding,
		needsImmediateAction: false,
		needsAcknowledgment: false,
	},
	isDeliveriesOutstanding: {
		status: ShipmentStatusFilter.TodaysDeliveriesOutstanding,
		needsImmediateAction: false,
		needsAcknowledgment: false,
	},
} as const;

export type FilterMappingKey = keyof typeof filterMappings;
